






































import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'BasePrice',
  props: {
    regular: {
      type: [String, Number],
      default: null,
    },
    special: {
      type: [String, Number],
      default: null,
    },
    rrp: {
      type: [String, Number],
      default: null,
    },
  },
  data(...args): any {
    return args;
  },
});
